import React from 'react'

export default function AuthorizationRequired() {
  return (
    <svg
      width='369'
      height='391'
      viewBox='0 0 369 391'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='183.28' cy='183.28' r='183.28' fill='#F5F8FF' />
      <circle cx='183.286' cy='183.28' r='142.551' fill='#E4ECFE' />
      <rect
        width='44.4177'
        height='7.65822'
        rx='3.82911'
        transform='matrix(-0.707107 0.707107 0.707107 0.707107 61.5625 63.3281)'
        fill='#405189'
      />
      <rect
        width='44.4177'
        height='7.65822'
        rx='3.82911'
        transform='matrix(0.707107 0.707107 0.707107 -0.707107 30.1562 68.7441)'
        fill='#405189'
      />
      <circle cx='79.4352' cy='169.904' r='13.0914' stroke='#405189' stroke-width='12.0625' />
      <circle cx='351.645' cy='209.911' r='10.8796' stroke='#405189' stroke-width='12.0625' />
      <circle cx='30.4882' cy='232.535' r='3.34758' stroke='#405189' stroke-width='9.04688' />
      <path
        d='M189.732 373.81C255.69 373.81 309.16 370.689 309.16 366.838C309.16 362.987 255.69 359.865 189.732 359.865C123.774 359.865 70.3047 362.987 70.3047 366.838C70.3047 370.689 123.774 373.81 189.732 373.81Z'
        fill='#B7CEFF'
      />
      <rect
        width='38.6011'
        height='6.65535'
        rx='3.32768'
        transform='matrix(-0.707107 0.707107 0.707107 0.707107 334.887 111.578)'
        fill='#405189'
      />
      <rect
        width='38.6011'
        height='6.65535'
        rx='3.32768'
        transform='matrix(0.707107 0.707107 0.707107 -0.707107 307.594 116.284)'
        fill='#405189'
      />
      <rect
        width='32.7379'
        height='5.64446'
        rx='2.82223'
        transform='matrix(-0.707107 0.707107 0.707107 0.707107 134.727 322.672)'
        fill='#405189'
      />
      <rect
        width='32.7379'
        height='5.64446'
        rx='2.82223'
        transform='matrix(0.707107 0.707107 0.707107 -0.707107 111.578 326.664)'
        fill='#405189'
      />
      <path
        d='M83.9358 67.9688H285.816C291.321 67.9688 295.756 74.2883 295.655 81.9914L292.814 301.201C292.68 311.518 286.619 319.746 274.21 319.617L83.074 316.26C79.9297 316.205 77.1195 314.293 75.9041 311.389C74.8942 308.975 73.9989 305.834 74 302.403L74.0941 81.7338C74.0984 74.1302 78.5035 67.9688 83.9358 67.9688Z'
        fill='#405189'
      />
      <path
        d='M88.3905 73.9048H282.244C287.529 73.9048 291.787 79.9093 291.692 87.2281L288.965 295.508C288.836 305.311 283.016 313.129 275.937 313.006L88.1818 309.743C83.008 309.653 78.8483 303.817 78.8516 296.65L78.9413 86.9834C78.9446 79.7588 83.1734 73.9048 88.3905 73.9048Z'
        fill='#F5F8FF'
      />
      <path
        d='M291.394 105.107H78.8477V76.0576C78.8477 74.5083 80.1019 73.2524 81.6492 73.2524H288.75C290.21 73.2524 291.394 74.438 291.394 75.8996V105.107Z'
        fill='#B7CEFF'
      />
      <path
        d='M267.712 91.5275L157.443 90.4806C154.843 90.4557 152.752 88.7364 152.751 86.6241L152.75 82.943C152.75 81.3136 154.375 79.9917 156.381 79.9917H268.501C270.479 79.9917 272.039 81.3569 271.894 82.9593L271.364 88.8014C271.226 90.3517 269.626 91.5448 267.712 91.5275Z'
        fill='#405189'
      />
      <path
        opacity='0.6'
        d='M281.626 124.143H88.6034C87.3232 124.143 86.2852 123.108 86.2852 121.83V115.644C86.2852 114.359 87.3362 113.319 88.6239 113.331L281.647 115.033C282.919 115.044 283.945 116.077 283.945 117.346V121.83C283.946 123.108 282.906 124.143 281.626 124.143Z'
        fill='#B7CEFF'
      />
      <path
        d='M134.735 90.615C131.599 90.615 129.047 88.0599 129.047 84.9191C129.047 81.7782 131.599 79.2231 134.735 79.2231C137.872 79.2231 140.424 81.7782 140.424 84.9191C140.424 88.0599 137.872 90.615 134.735 90.615ZM134.735 79.9453C131.997 79.9453 129.767 82.1767 129.767 84.9191C129.767 87.6614 131.995 89.8939 134.735 89.8939C137.475 89.8939 139.703 87.6625 139.703 84.9191C139.704 82.1767 137.475 79.9453 134.735 79.9453Z'
        fill='#F5F8FF'
      />
      <path
        d='M116.29 91.0481C113.153 91.0481 110.602 88.493 110.602 85.3522C110.602 82.2113 113.153 79.6562 116.29 79.6562C119.427 79.6562 121.979 82.2113 121.979 85.3522C121.979 88.493 119.427 91.0481 116.29 91.0481ZM116.29 80.3773C113.551 80.3773 111.323 82.6087 111.323 85.3522C111.323 88.0946 113.551 90.327 116.29 90.327C119.029 90.327 121.259 88.0956 121.259 85.3522C121.257 82.6087 119.029 80.3773 116.29 80.3773Z'
        fill='#F5F8FF'
      />
      <path
        d='M98.5714 91.0481C95.4346 91.0481 92.8828 88.493 92.8828 85.3522C92.8828 82.2113 95.4346 79.6562 98.5714 79.6562C101.708 79.6562 104.26 82.2113 104.26 85.3522C104.26 88.493 101.708 91.0481 98.5714 91.0481ZM98.5714 80.3773C95.8325 80.3773 93.6029 82.6087 93.6029 85.3522C93.6029 88.0946 95.8314 90.327 98.5714 90.327C101.31 90.327 103.539 88.0956 103.539 85.3522C103.539 82.6087 101.311 80.3773 98.5714 80.3773Z'
        fill='#F5F8FF'
      />
      <path
        opacity='0.6'
        d='M205.326 142.796L169.226 142.496C168.095 142.486 167.186 141.561 167.195 140.428L167.204 139.42C167.213 138.314 168.097 137.415 169.201 137.387L205.311 136.493C206.468 136.465 207.42 137.401 207.41 138.56L207.392 140.763C207.382 141.895 206.457 142.806 205.326 142.796Z'
        fill='#B7CEFF'
      />
      <path
        opacity='0.6'
        d='M213.106 208.48L159.956 208.037C158.16 208.022 156.717 206.552 156.731 204.753L157.173 151.451C157.188 149.685 158.604 148.253 160.368 148.223L212.853 149.22C215.076 149.262 216.85 151.088 216.831 153.314L216.384 205.25C216.37 207.049 214.902 208.495 213.106 208.48Z'
        fill='#B7CEFF'
      />
      <path
        opacity='0.6'
        d='M138.166 142.796L102.066 142.496C100.935 142.486 100.026 141.561 100.035 140.428L100.044 139.42C100.053 138.314 100.937 137.415 102.041 137.387L138.151 136.493C139.308 136.465 140.26 137.401 140.25 138.56L140.231 140.763C140.222 141.895 139.297 142.806 138.166 142.796Z'
        fill='#B7CEFF'
      />
      <path
        opacity='0.6'
        d='M145.95 208.48L92.7998 208.037C91.0038 208.022 89.5603 206.552 89.5743 204.753L90.0166 151.451C90.0317 149.685 91.4482 148.253 93.2117 148.223L145.697 149.22C147.92 149.262 149.694 151.088 149.675 153.314L149.228 205.25C149.213 207.049 147.746 208.495 145.95 208.48Z'
        fill='#B7CEFF'
      />
      <path
        opacity='0.6'
        d='M272.682 144.057L236.581 143.756C235.45 143.747 234.541 142.821 234.551 141.689L234.56 140.681C234.568 139.574 235.453 138.675 236.557 138.647L272.667 137.753C273.824 137.725 274.775 138.661 274.765 139.82L274.747 142.023C274.737 143.157 273.813 144.066 272.682 144.057Z'
        fill='#B7CEFF'
      />
      <path
        opacity='0.6'
        d='M280.465 209.741L227.315 209.298C225.519 209.283 224.076 207.813 224.09 206.014L224.532 152.712C224.547 150.947 225.964 149.514 227.727 149.484L280.212 150.481C282.435 150.523 284.21 152.35 284.19 154.576L283.744 206.511C283.73 208.309 282.261 209.755 280.465 209.741Z'
        fill='#B7CEFF'
      />
      <path
        opacity='0.6'
        d='M282.902 253.198C282.902 256.772 279.979 259.657 276.409 259.604L91.8277 256.894C88.7537 256.848 86.2852 254.34 86.2852 251.261V219.201C86.2852 216.071 88.8337 213.541 91.9586 213.568L277.325 215.133C280.356 215.159 282.821 217.583 282.902 220.616V253.198Z'
        fill='#B7CEFF'
      />
      <path
        opacity='0.6'
        d='M275.065 281.785L91.3552 279.42C88.5439 279.385 86.2852 277.093 86.2852 274.278V266.792C86.2852 264.871 87.853 263.322 89.7712 263.347L279.079 265.844C281.777 265.879 283.946 268.079 283.946 270.782V273.008C283.946 277.899 279.95 281.848 275.065 281.785Z'
        fill='#B7CEFF'
      />
      <path
        d='M67.142 110.149C38.2 146.995 44.5699 200.357 81.37 229.337C111.28 252.89 152.086 253.085 181.858 232.548L309.716 333.233C311.839 334.905 314.67 335.374 317.219 334.474L332.804 328.972C333.072 328.878 333.33 328.766 333.582 328.646C333.653 328.613 333.721 328.574 333.791 328.538C333.979 328.442 334.162 328.339 334.339 328.228C334.399 328.19 334.46 328.153 334.519 328.114C334.742 327.968 334.955 327.813 335.159 327.647C335.162 327.645 335.165 327.642 335.169 327.639C337.343 325.86 338.474 322.995 337.943 320.094L332.33 289.429C331.983 287.535 330.957 285.834 329.446 284.642L316.639 274.558L311.368 281.269L300.366 272.606L305.637 265.894L295.345 257.79L290.495 263.964L277.125 253.435L281.974 247.261L276.993 243.337L274.496 246.515L263.287 237.689L265.784 234.511L257.065 227.646L251.794 234.357L245.567 229.453L250.838 222.742L245.441 218.492L240.17 225.203L229.376 216.703L234.648 209.992L219.477 198.044L212.979 192.927C225.895 159.117 216.089 119.456 186.178 95.9014C149.377 66.923 96.083 73.3012 67.142 110.149ZM114.493 125.572C121.945 131.439 123.235 142.246 117.374 149.707C111.514 157.168 100.721 158.459 93.2698 152.592C85.8184 146.724 84.5276 135.918 90.389 128.457C96.2504 120.995 107.042 119.704 114.493 125.572Z'
        fill='url(#paint0_linear_15063_3508)'
      />
      <path
        d='M177.454 158.494L238.065 206.224L232.794 212.935L243.587 221.435L248.859 214.724L254.255 218.974L248.984 225.685L255.211 230.589L260.483 223.878L269.201 230.744L266.705 233.922L277.913 242.748L280.41 239.571L285.392 243.494L280.542 249.668L293.913 260.197L298.762 254.023L309.055 262.129L303.784 268.84L314.785 277.503L320.057 270.792L332.863 280.877C334.375 282.067 335.401 283.77 335.747 285.664L341.361 316.329C342.06 320.15 339.881 323.914 336.221 325.206L320.636 330.707C318.088 331.606 315.258 331.138 313.133 329.466L158.789 207.921L177.454 158.494Z'
        fill='#F16645'
      />
      <path
        d='M84.7919 225.569C121.592 254.549 174.885 248.169 203.826 211.323C232.768 174.476 226.398 121.113 189.598 92.1347C152.798 63.1564 99.5049 69.5334 70.5639 106.381C41.6218 143.228 47.9918 196.59 84.7919 225.569ZM96.6928 148.823C89.2413 142.955 87.9506 132.149 93.812 124.687C99.6723 117.226 110.465 115.935 117.916 121.803C125.368 127.671 126.658 138.476 120.797 145.938C114.936 153.4 104.144 154.691 96.6928 148.823Z'
        fill='url(#paint1_linear_15063_3508)'
      />
      <path
        d='M185.28 228.78L313.137 329.465C315.261 331.138 318.092 331.606 320.64 330.706L336.226 325.205C338.576 324.375 340.302 322.521 341.06 320.292C330.914 303.609 218.436 224.89 216.051 212.867C215.202 208.591 216.121 202.556 222.897 194.275L216.4 189.159C229.316 155.348 219.51 115.687 189.599 92.1325C152.798 63.1552 99.5049 69.5333 70.5639 106.381C41.6218 143.228 47.9918 196.591 84.7919 225.569C114.702 249.123 155.508 249.318 185.28 228.78ZM117.915 121.804C125.367 127.672 126.657 138.477 120.796 145.939C114.936 153.4 104.143 154.692 96.6917 148.824C89.2402 142.956 87.9495 132.15 93.8109 124.688C99.6723 117.227 110.464 115.936 117.915 121.804Z'
        fill='url(#paint2_linear_15063_3508)'
      />
      <path
        d='M95.0755 212.475C124.653 235.767 167.487 230.641 190.748 201.025C214.009 171.41 208.89 128.52 179.312 105.229C149.734 81.9374 106.9 87.065 83.6392 116.679C60.3783 146.294 65.4983 189.183 95.0755 212.475ZM96.6924 148.823C89.241 142.955 87.9502 132.149 93.8116 124.687C99.6719 117.226 110.464 115.935 117.916 121.803C125.367 127.671 126.658 138.476 120.797 145.938C114.935 153.4 104.144 154.691 96.6924 148.823Z'
        fill='#F16645'
      />
      <path
        d='M155.639 255.312L137.083 236.756L60.6178 302.02C51.2528 310.014 50.6894 324.293 59.3956 332.999C68.1018 341.705 82.3812 341.142 90.3745 331.777L155.639 255.312Z'
        fill='#405189'
      />
      <path
        d='M142.461 270.747L90.371 331.776C82.3777 341.141 68.0983 341.704 59.3921 332.998C50.6859 324.292 51.2493 310.013 60.6143 302.019L128.741 243.872C131.483 253.755 136.201 262.854 142.461 270.747Z'
        fill='#405189'
      />
      <path
        d='M176.816 143.96L224.779 255.312C225.517 254.741 226.249 254.149 226.968 253.55C231.604 249.63 235.641 245.024 238.945 239.885L197.517 143.702C190.654 142.572 183.651 142.659 176.816 143.96Z'
        fill='white'
      />
      <path
        d='M142.73 163.278L187.824 267.97C197.191 267.981 206.435 265.788 214.84 261.563L165.6 147.238C156.876 150.726 149.052 156.213 142.73 163.278Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M215.241 159.353C223.973 165.036 230.89 173.259 235.087 183.004C239.286 192.751 240.567 203.564 238.758 214.068C236.95 224.571 232.139 234.265 224.963 241.933C217.789 249.599 208.575 254.894 198.501 257.181C188.427 259.467 177.917 258.65 168.289 254.827L168.288 254.826C161.892 252.287 156.036 248.48 151.058 243.612C146.08 238.744 142.078 232.911 139.291 226.44C136.504 219.97 134.988 212.994 134.835 205.913C134.683 198.832 135.897 191.794 138.403 185.201L138.404 185.201C142.178 175.272 148.736 166.741 157.218 160.666C165.698 154.593 175.728 151.24 186.039 151.007C196.349 150.775 206.511 153.671 215.241 159.353ZM251.224 176.053C245.673 163.169 236.497 152.224 224.825 144.628C213.15 137.029 199.514 133.129 185.642 133.442C171.77 133.755 158.319 138.267 146.988 146.382C135.66 154.495 126.968 165.838 121.981 178.957C118.668 187.669 117.069 196.957 117.27 206.292C117.471 215.627 119.469 224.835 123.155 233.391C126.841 241.948 132.145 249.692 138.774 256.174C145.403 262.656 153.227 267.75 161.804 271.156C174.722 276.286 188.849 277.388 202.39 274.315C215.928 271.242 228.244 264.14 237.791 253.938C247.336 243.739 253.688 230.899 256.073 217.049C258.458 203.2 256.773 188.936 251.224 176.053Z'
        fill='#405189'
      />
      <path
        d='M67.4676 302.629L122.558 257.518C124.266 256.119 126.255 258.086 124.873 259.806L80.3866 315.136C78.6701 317.271 76.1913 318.658 73.6096 318.928L72.0822 319.088C66.8073 319.639 62.8385 315.47 63.6161 310.195L63.797 308.968C64.1535 306.549 65.4815 304.256 67.4676 302.629Z'
        fill='#9FBDFF'
      />
      <defs>
        <linearGradient
          id='paint0_linear_15063_3508'
          x1='222.267'
          y1='186.002'
          x2='164.59'
          y2='275.626'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#E1473D' />
          <stop offset='1' stop-color='#E9605A' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_15063_3508'
          x1='92.5525'
          y1='70.6942'
          x2='293.934'
          y2='467.349'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF9085' />
          <stop offset='1' stop-color='#FB6FBB' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_15063_3508'
          x1='65.8958'
          y1='311.341'
          x2='272.065'
          y2='165.493'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF928E' />
          <stop offset='1' stop-color='#FE7062' />
        </linearGradient>
      </defs>
    </svg>
  )
}
